import { apiHolder, apis } from 'api';
import { FLOLDER } from '@web-mail/common/constant';
import moment from 'moment';
const systemApi = apiHolder.api.getSystemApi();
const mailConfApi = apiHolder.api.requireLogicalApi(apis.mailConfApiImpl);
const productAuthApi = apiHolder.api.requireLogicalApi(apis.productAuthApiImpl);
const trackApi = apiHolder.api.requireLogicalApi(apis.dataTrackerApiImp);
const accountApi = apiHolder.api.requireLogicalApi(apis.accountApiImpl);
export const getVisibleStructHeight = (data, forceShowAttachemt, showSuborbinateFrom) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
    const isCorpMail = systemApi.getIsCorpMailMode();
    const isFree = productAuthApi.doGetProductVersionId() === 'free';
    const isSirius = productAuthApi.doGetProductVersionId() === 'sirius';
    const isOther = productAuthApi.doGetProductVersionId() !== 'free' && productAuthApi.doGetProductVersionId() !== 'sirius';
    const tightness = mailConfApi.getMailListTightness();
    const dayLimit = mailConfApi.getMailDayLimit();
    const { from, summary, desc, attachments, sendStatus, readStatus, taskDeadline, suborbinateSearchFrom } = structHeightMap[+tightness - 1];
    const res = {
        from,
        summary,
        desc,
    };
    if (data && ((_a = data.entry.attachment) === null || _a === void 0 ? void 0 : _a.length)) {
        let attachment = [];
        attachment = (_b = data.entry.attachment) === null || _b === void 0 ? void 0 : _b.filter(item => item.inlined === false && item.fileType !== 'ics' && item.type !== 'netfolder');
        if (attachment.length) {
            res.attachments = attachments;
        }
    }
    if (!isCorpMail && data && data.entry.sendStatus) {
        res.sendStatus = sendStatus;
    }
    const accountAlias = ((_d = (_c = systemApi.getCurrentUser(data === null || data === void 0 ? void 0 : data._account)) === null || _c === void 0 ? void 0 : _c.prop) === null || _d === void 0 ? void 0 : _d.accountAlias) || [];
    const accountAliasArray = Array.isArray(accountAlias) ? accountAlias : [accountAlias];
    const senderEmail = ((_g = (_f = (_e = data === null || data === void 0 ? void 0 : data.sender) === null || _e === void 0 ? void 0 : _e.contact) === null || _f === void 0 ? void 0 : _f.contact) === null || _g === void 0 ? void 0 : _g.accountName) || '';
    const isSend = ((_h = data === null || data === void 0 ? void 0 : data.entry) === null || _h === void 0 ? void 0 : _h.folder) === FLOLDER.SENT ||
        accountAliasArray.some(account => accountApi.getIsSameSubAccountSync(account, senderEmail)) ||
        accountApi.getIsSameSubAccountSync(senderEmail, data._account);
    const dateArr = (_k = (_j = data.entry.sendTime) === null || _j === void 0 ? void 0 : _j.trim()) === null || _k === void 0 ? void 0 : _k.split(/\s+/);
    let isBeforeday = false;
    if (!((_l = data.entry) === null || _l === void 0 ? void 0 : _l.sendTime) || !dateArr || (dateArr === null || dateArr === void 0 ? void 0 : dateArr.length) < 2) {
        isBeforeday = true;
    }
    else {
        const utcStr = dateArr[0] + 'T' + dateArr[1] + '+08:00';
        const sendValue = moment(utcStr);
        if (moment().add(-dayLimit.thirdDayLimit, 'day').isAfter(sendValue, 'day')) {
            isBeforeday = true;
        }
        else {
            isBeforeday = false;
        }
    }
    const showOpenRecord = data.authAccountType && data.authAccountType !== '0' && !isBeforeday && isSirius;
    if (!isCorpMail &&
        !isFree &&
        data &&
        isSend &&
        !data.taskId &&
        ((isSirius && (data.entry.rcptCount || data.entry.readCount)) || (isOther && (data.entry.rcptCount || data.entry.innerRead)) || showOpenRecord)) {
        res.readStatus = readStatus;
    }
    if (!isCorpMail && data && data.taskId && data.taskInfo) {
        res.taskDeadline = taskDeadline;
        res.desc = null;
    }
    const showDesc = mailConfApi.getMailShowDesc();
    const showAttachment = forceShowAttachemt || mailConfApi.getMailShowAttachment();
    if (!showDesc) {
        res.desc = null;
    }
    if (!showAttachment) {
        res.attachments = null;
    }
    if (showSuborbinateFrom && !!data.isTpMail && data.mailFrom === 'subordinate' && ((_m = data === null || data === void 0 ? void 0 : data.tpMailInfo) === null || _m === void 0 ? void 0 : _m.subordinateSearch) && ((_o = data.tpMailInfo.receiverSD) === null || _o === void 0 ? void 0 : _o.length)) {
        res.suborbinateSearchFrom = suborbinateSearchFrom;
    }
    return res;
};
export const getCardHeight = (data, forceShowAttachemt, showSuborbinateFrom) => {
    if (data) {
        let baseHeight = 0;
        const tightness = mailConfApi.getMailListTightness();
        if (+tightness === 1) {
            baseHeight = 24;
        }
        else if (+tightness === 2) {
            baseHeight = 20;
        }
        else if (+tightness === 3) {
            baseHeight = 16;
        }
        let sumHeight = baseHeight;
        const heightMap = getVisibleStructHeight(data, forceShowAttachemt, showSuborbinateFrom);
        Object.values(heightMap).forEach(height => {
            sumHeight += height;
        });
        return sumHeight;
    }
    return 0;
};
const structHeightMap1 = {
    from: 20,
    summary: 22,
    desc: 22,
    attachments: 32,
    sendStatus: 24,
    readStatus: 24,
    taskDeadline: 24,
    suborbinateSearchFrom: 22,
};
const structHeightMap2 = {
    from: 16,
    summary: 20,
    desc: 20,
    attachments: 30,
    sendStatus: 24,
    readStatus: 24,
    taskDeadline: 24,
    suborbinateSearchFrom: 20,
};
const structHeightMap3 = {
    from: 16,
    summary: 18,
    desc: 18,
    attachments: 28,
    sendStatus: 24,
    readStatus: 24,
    taskDeadline: 24,
    suborbinateSearchFrom: 18,
};
const structHeightMap = [structHeightMap1, structHeightMap2, structHeightMap3];
